module.exports = __webpack_public_path__ + "img/goofball_island.6ed03ad7.jpg";